export interface GetConnectionReportsAsyncPayload {
    id: string;
    start_date: string;
    end_date: string;
}

export interface GetConnectionSourceMappingAsyncPayload {
    id: string;
}

export interface LeadReportsState {
    isReportsLoading: boolean;
    connectionReport: any;
    isSourceMappingLoading: boolean;
    sourceMapping: any;
}

export const initialState: LeadReportsState = {
    isReportsLoading: false,
    connectionReport: null,
    isSourceMappingLoading: false,
    sourceMapping: null,
};
